import React from 'react';
import { useNavigate } from 'react-router-dom';
import cryingUnicorn from '../assets/unicorn-crying.20418b9a43833b58b562.png';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#2a2a2a] flex flex-col items-center justify-center p-6">
      <div className="max-w-md w-full text-center">
        {/* Crying Unicorn Icon */}
        <div className="mb-12">
          <img src={cryingUnicorn} alt="Sad Unicorn" className="w-32 h-32 mx-auto" />
        </div>

        {/* 404 Number */}
        <h1 className="text-7xl font-normal text-white mb-6">404</h1>

        {/* Message */}
        <h2 className="text-3xl font-normal text-white mb-12">Page Not Found</h2>

        {/* Home Button - with border like Old PRAIRI */}
        <div className="mb-16">
          <button
            onClick={() => navigate('/')}
            className="px-12 py-3 border-2 border-white text-white font-normal text-lg rounded-lg hover:bg-white hover:text-[#2a2a2a] transition-all"
          >
            Home
          </button>
        </div>

        {/* Help Text */}
      </div>
    </div>
  );
};

export default NotFoundPage;
